import React, { useEffect, useState } from "react";
import {
  updateFormContentPreview,
  getFormContentPreview,
  imageUploadClientPreview,
} from "../../../../api/services/services";
import { Grid, Button, Snackbar, Box } from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import { Bucket } from "../../../../api/config/apiConfig";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import CircularProgress from "@mui/material/CircularProgress";
import Input from "../../../atoms/Input";
import removeImg from "../../../../imgs/remove.png";
import { useParams } from "react-router-dom";
import Typography from "@mui/material/Typography";
import ContactDetailField from "../../../molecules/ContactDetailField";
import DynamicText from "../../../molecules/DynamicText";
import { useLocation } from "react-router-dom";
import PrintComponent from "../../PrintComponent";
import PackingInventoryDownload from "./download";
import moment from "moment";
import MySignatureCanvas from "../../../molecules/signature_canvas";
import PremiumPublicLayout from "../../../templates/PremiumPublicLayout";
import PremiumCard from "../../../molecules/PremiumCard";
import SectionHeader from "../../../molecules/SectionHeader";
import InventoryIcon from "@mui/icons-material/Inventory";
import DescriptionIcon from "@mui/icons-material/Description";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import CommentIcon from "@mui/icons-material/Comment";
import GavelIcon from "@mui/icons-material/Gavel";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import NoteAltIcon from "@mui/icons-material/NoteAlt";

const PackingInventoryClientSide = () => {
  const [formContent, setFormContent] = useState({});
  const [formContentId, setFormContentId] = useState("");

  const [surveyData, setSurveyData] = useState([]);

  const [isEdit, setIsEdit] = useState(false);

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const [isLoading, setIsLoading] = useState(false);

  const location = useLocation();
  const urlData = new URLSearchParams(location.search);
  const email = urlData.get("email");
  const surveyId = urlData.get("surveyId");
  const formId = urlData.get("formId");
  const token = urlData.get("token");

  var totalAmount = 0;

  const [clientInd, setClientInd] = useState(-1);

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  const [mediaKeysToSend, setMediaKeysToSend] = useState([]);

  //
  const updateContent = (data, md) => {
    setIsLoading(true);

    let media = [];
    let mediaInd = 0;
    formContent?.clients?.map((cl, ind) => {
      if (cl?.sign?.trim()?.length > 0) {
        media[mediaInd] = cl?.sign;
        mediaInd++;
      }

      return <></>;
    });

    const body = {
      formContentId: formContentId,
      content: data ? data : formContent,
      mediaKeys: md,
      removedMediaKeys: [],
    };
    updateFormContentPreview(
      surveyId,
      formId,
      email,
      token,
      body,
      formContentId
    )
      .then((res) => {
        setSnackbarMessage("Signature has been added successfully!");

        setOpenSnackbar(true);
        getContent();
        setIsEdit(false);

        setIsLoading(false);
        setUploadTextClient1("Upload Sign");
        setUploadTextClient2("Upload Sign");
      })
      .catch((error) => {
        setSnackbarMessage(error?.response?.data?.message);
        setOpenSnackbar(true);

        if (error?.response?.data?.statusCode == 401) {
          setIsValid(false);
        }
        setUploadTextClient1("Upload Sign");
        setUploadTextClient2("Upload Sign");
        setIsLoading(false);
      });
  };

  const [isValid, setIsValid] = useState(false);

  //
  const getContent = () => {
    setIsLoading(true);
    getFormContentPreview(surveyId, formId, email, token)
      .then((res) => {
        setIsValid(true);
        setFormContentId(res.data.data.uuid);
        setFormContent(res.data.data.content);

        for (let i = 0; i < res.data.data.content?.clients?.length; i++) {
          if (res.data.data.content?.clients?.[i]?.email == email) {
            setClientInd(i);
            i = res.data.data.content?.length;
          }
        }

        setIsLoading(false);
      })
      .catch((error) => {
        setIsValid(false);
        setSnackbarMessage(error?.response?.data?.message);
        setOpenSnackbar(true);

        setIsLoading(false);
      });
  };

  useEffect(() => {
    getContent();
  }, []);



  const [downloadText, setDownloadText] = useState("download");

  const getTargetElement = () => document.getElementById("content-id");

  const [uploadTextClient1, setUploadTextClient1] = useState("Upload Sign");
  const [uploadTextClient2, setUploadTextClient2] = useState("Upload Sign");

  const [uploadText1, setUploadText1] = useState("Upload Sign");
  const [uploadText2, setUploadText2] = useState("Upload Sign");


  const [isSignCanvas, setSignCanvas] = useState(false);
  const [whichSign, setWhichSign] = useState("");

  //
  const uploadFile = async (file) => {

    setIsLoading(true);

    if (whichSign == "destClient") setUploadTextClient1("Uploading...");
    if (whichSign == "originClient") setUploadTextClient2("Uploading...");
    const fd = new FormData();
    fd.append("image", file);

    imageUploadClientPreview(fd, surveyId, formId, email, token)
      .then((res) => {
        let values = { ...formContent };
        // values.clients[clientInd].sign = res?.data?.data?.key;
        // if (email == formContent?.clientEmail)
        //   values.clientSign = res?.data?.data?.key;

        if (whichSign == "destClient")
          values.clientSignDestination = res?.data?.data?.key;
        if (whichSign == "originClient") values.clientSign = res?.data?.data?.key;

        let md = [...mediaKeysToSend];
        md.push(res?.data?.data?.key);
        setMediaKeysToSend(md);

        setFormContent(values);

        setTimeout(() => {
          updateContent(values, [res?.data?.data?.key]);
        }, 1500);
      })
      .catch((error) => {
        setSnackbarMessage(error?.response?.data?.message);
        setOpenSnackbar(true);

        if (error?.response?.data?.statusCode == 401) {
          setIsValid(false);
        }

        setUploadTextClient1("Upload Sign");
        setUploadTextClient2("Upload Sign");

        setIsLoading(false);
      });

  };

  //
  const uploadFileContractor = async (event, val) => {
    event.preventDefault();
    setIsLoading(true);

    if (event.target.files.length > 0) {
      if (val == "destContractor") setUploadText1("Uploading...");
      if (val == "originContractor") setUploadText2("Uploading...");

      const fd = new FormData();
      fd.append("image", event.target.files[0]);

      imageUploadClientPreview(fd, surveyId, formId, email, token)
        .then((res) => {
          let values = { ...formContent };
          if (val == "destContractor")
            values.destContractorSign = res?.data?.data?.key;
          if (val == "originContractor")
            values.originContractorSign = res?.data?.data?.key;
          setFormContent(values);

          let md = [...mediaKeysToSend];
          md.push(res?.data?.data?.key);
          setMediaKeysToSend(md);

          setIsLoading(false);
          setUploadText1("Upload Sign");
          setUploadText2("Upload Sign");

          setTimeout(() => {
            updateContent(values, [res?.data?.data?.key]);
          }, 1500);
        })
        .catch((error) => {
          setSnackbarMessage(error?.response?.data?.message);
          setOpenSnackbar(true);

          if (error?.response?.data?.statusCode == 401) {
            localStorage.clear();
            window.location.pathname = "/login";
          }

          setUploadText1("Upload Sign");
          setUploadText2("Upload Sign");

          setIsLoading(false);
        });
    }
  };

  const printAction = () => {
    // Simply trigger the print dialog. 
    // The table-based layout in PrintComponent handles pagination automatically.
    setTimeout(() => {
      window.print();
    }, 500);
  };



  return (
    <>
      {isValid ? (
         <PremiumPublicLayout
            title="Packing Inventory"
            hideBackButton={true}
            actions={
                <div className="d-flex gap-3">
                    {!isEdit && email != formContent?.clientEmail && (
                        <Button
                            variant="contained"
                            onClick={() => {
                                setIsEdit(true);
                            }}
                            disabled={isLoading}
                             sx={{ 
                                textTransform: "none", 
                                borderRadius: "var(--radius-md)", 
                                padding: "10px 24px",
                                fontWeight: 700,
                                backgroundColor: "var(--primary-color)",
                                boxShadow: "0 4px 12px rgba(79, 70, 229, 0.2)",
                                '&:hover': { backgroundColor: 'var(--primary-hover)' }
                            }}
                            startIcon={<NoteAltIcon />}
                        >
                            Edit
                        </Button>
                    )}
                    {isEdit && email != formContent?.clientEmail && (
                         <Button
                            variant="outlined"
                             color="error"
                            onClick={() => {
                                getContent();
                                setIsEdit(false);
                            }}
                            disabled={isLoading}
                             sx={{ textTransform: "none", borderRadius: "var(--radius-md)", fontWeight: 700, padding: "10px 24px", border: "1px solid" }}
                        >
                            Cancel
                        </Button>
                    )}
                    {isEdit && email != formContent?.clientEmail && (
                         <Button
                            variant="contained"
                            onClick={() => {
                                updateContent();
                            }}
                            disabled={isLoading}
                             sx={{ 
                                textTransform: "none", 
                                borderRadius: "var(--radius-md)", 
                                padding: "10px 32px",
                                fontWeight: 700,
                                backgroundColor: "var(--primary-color)",
                                boxShadow: "0 4px 12px rgba(79, 70, 229, 0.3)",
                                '&:hover': { backgroundColor: 'var(--primary-hover)' }
                            }}
                        >
                            Save
                        </Button>
                    )}
                    {!isEdit && (
                         <Button
                            variant="contained"
                            onClick={() => {
                                if (window.innerWidth <= 768) { if (typeof setSnackbarMessage !== "undefined" && typeof setOpenSnackbar !== "undefined") { setSnackbarMessage("For a good experience, please use a desktop screen"); setOpenSnackbar(true); } else { alert("For a good experience, please use a desktop screen"); } return; }
                                const tempTitle = document.title;
                                const newTitle = `Packing-Inventory-${formContent?.clientName || 'Document'}-${moment().format("DD.MM.YYYY")}`;
                                document.title = newTitle;
                                
                                // Call printAction which handles the print
                                printAction();
                                
                                // Restore title after a longer delay to ensure print dialog caught it
                                setTimeout(() => {
                                    document.title = tempTitle;
                                }, 2000);
                            }}
                            disabled={isLoading}
                             sx={{ 
                                textTransform: "none", 
                                borderRadius: "var(--radius-md)", 
                                padding: "10px 24px",
                                fontWeight: 700,
                                backgroundColor: "var(--text-main)",
                                boxShadow: "0 4px 12px rgba(15, 23, 42, 0.2)",
                                '&:hover': { backgroundColor: '#000' }
                            }}
                            startIcon={<DescriptionIcon />}
                        >
                            Save as PDF
                        </Button>
                    )}
                </div>
            }
        >
            <SectionHeader title="Details" icon={<DescriptionIcon />} />
            <PremiumCard sx={{ marginBottom: "32px" }}>
                <Grid container spacing={3} sx={{ mb: 3 }}>
                    <Grid item xs={12} md={4}>
                         <ContactDetailField
                            label="Client Name"
                             isEdit={isEdit}
                             type="text"
                             minWidth={"100%"}
                             value={formContent?.clientName}
                             onChange={(e) => {
                                 const values = { ...formContent };
                                 values.clientName = e.target.value;
                                 setFormContent(values);
                             }}
                         />
                    </Grid>
                     <Grid item xs={12} md={4}>
                         <ContactDetailField
                            label="Origin Address"
                             isEdit={isEdit}
                             type="text"
                             minWidth={"100%"}
                             value={formContent?.originAddress}
                             onChange={(e) => {
                                 const values = { ...formContent };
                                 values.originAddress = e.target.value;
                                 setFormContent(values);
                             }}
                         />
                    </Grid>
                     <Grid item xs={12} md={4}>
                         <ContactDetailField
                            label="Destination Address"
                             isEdit={isEdit}
                             type="text"
                             minWidth={"100%"}
                             value={formContent?.destinationAddress}
                             onChange={(e) => {
                                 const values = { ...formContent };
                                 values.destinationAddress = e.target.value;
                                 setFormContent(values);
                             }}
                         />
                    </Grid>
                </Grid>
                <Grid container spacing={3}>
                     <Grid item xs={12} sm={6} md={3}>
                         <ContactDetailField
                            label="Organization"
                             isEdit={isEdit}
                             type="text"
                             minWidth={"100%"}
                             value={formContent?.organization}
                             onChange={(e) => {
                                 const values = { ...formContent };
                                 values.organization = e.target.value;
                                 setFormContent(values);
                             }}
                         />
                    </Grid>
                     <Grid item xs={12} sm={6} md={3}>
                           <ContactDetailField
                            label="File Ref"
                            isEdit={isEdit}
                            type="text"
                            minWidth={"100%"}
                            value={formContent?.fileRef}
                            onChange={(e) => {
                                let values = { ...formContent };
                                values.fileRef = e.target.value;
                                setFormContent(values);
                            }}
                             disabled
                        />
                    </Grid>
                     <Grid item xs={12} sm={6} md={3}>
                           <ContactDetailField
                            label="Van No."
                            isEdit={isEdit}
                            type="text"
                            minWidth={"100%"}
                            value={formContent?.vanNo}
                            onChange={(e) => {
                                let values = { ...formContent };
                                values.vanNo = e.target.value;
                                setFormContent(values);
                            }}
                        />
                    </Grid>
                     <Grid item xs={12} sm={6} md={3}>
                           <ContactDetailField
                            label="Date"
                            isEdit={isEdit}
                            type="date"
                            minWidth={"100%"}
                            value={formContent?.date}
                            onChange={(e) => {
                                let values = { ...formContent };
                                values.date = e.target.value;
                                setFormContent(values);
                            }}
                        />
                    </Grid>
                </Grid>
            </PremiumCard>


            <SectionHeader title="Inventory Symbols" icon={<InventoryIcon />} />
            <PremiumCard sx={{ marginBottom: "32px" }}>
                <Grid container spacing={4} sx={{ mt: 1 }}>
                    <Grid item xs={12} md={6}>
                        <Typography variant="h6" sx={{ fontWeight: 700, mb: 3 }}>DESCRIPTIVE SYMBOLS</Typography>
                         <Grid container spacing={2}>
                             {[
                                { key: 'professionalBooks', label: 'PB - PROFESSIONAL BOOKS' },
                                { key: 'colorTV', label: 'C/T - COLOR TV' },
                                { key: 'professionalEquipments', label: 'PE - PROFESSIONAL EQUIPMENTS' },
                                { key: 'carrierDis', label: 'CD - CARRIER DISASSEMBLED' },
                                { key: 'professionalPapers', label: 'PP - PROFESSIONAL PAPERS' },
                                { key: 'disByOwner', label: 'DBO - DISASSEMBLED BY OWNER' },
                                { key: 'carrierPacked', label: 'CP - CARRIER PACKED' }
                             ].map(item => (
                                 <Grid item xs={6} key={item.key}>
                                     <div
                                        className={`p-2 d-flex justify-content-center align-items-center text-center cursor-pointer ${formContent?.descriptiveSymbols?.[item.key] ? "symbols-active" : "symbols-inactive"}`}
                                        style={{ minHeight: '60px', fontSize: '0.8rem', borderRadius: '8px', border: '1px solid #ddd' }}
                                        onClick={() => {
                                            let values = { ...formContent };
                                            values.descriptiveSymbols[item.key] = !values.descriptiveSymbols[item.key];
                                            setFormContent(values);
                                        }}
                                     >
                                        {item.label}
                                     </div>
                                 </Grid>
                             ))}
                         </Grid>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Typography variant="h6" sx={{ fontWeight: 700, mb: 3 }}>EXCEPTION SYMBOLS</Typography>
                        <Grid container spacing={2}>
                             {[
                                { key: 'rent', label: 'RE - RENT' },
                                { key: 'dented', label: 'D - DENTED' },
                                { key: 'rubbed', label: 'R - RUBBED' },
                                { key: 'broken', label: 'BR - BROKEN' },
                                { key: 'faded', label: 'F - FADED' },
                                { key: 'rusted', label: 'RU - RUSTED' },
                                { key: 'burned', label: 'BU - BURNED' },
                                { key: 'loose', label: 'L - LOOSE' },
                                { key: 'badly', label: 'W - BADLY' },
                                { key: 'chipped', label: 'CH - CHIPPED' },
                                { key: 'marred', label: 'M - MARRED' }
                             ].map(item => (
                                 <Grid item xs={4} key={item.key}>
                                     <div
                                        className={`p-2 d-flex justify-content-center align-items-center text-center cursor-pointer ${formContent?.exceptions?.[item.key] ? "symbols-active" : "symbols-inactive"}`}
                                        style={{ minHeight: '60px', fontSize: '0.8rem', borderRadius: '8px', border: '1px solid #ddd' }}
                                        onClick={() => {
                                            let values = { ...formContent };
                                            values.exceptions[item.key] = !values.exceptions[item.key];
                                            setFormContent(values);
                                        }}
                                     >
                                        {item.label}
                                     </div>
                                 </Grid>
                             ))}
                        </Grid>
                    </Grid>
                </Grid>
            </PremiumCard>


            <SectionHeader title="Items List" icon={<LocalShippingIcon />} />
            <PremiumCard sx={{ marginBottom: "32px", overflow: "hidden" }}>
              <TableContainer component={Paper} elevation={0} sx={{ maxHeight: 600 }}>
                <Table stickyHeader size="small">
                {/* Table Header */}
                <TableHead>
                  <TableRow>
                    <TableCell className="fw-bold" style={{ backgroundColor: '#f5f5f5', color: '#333' }}>
                      Item No.
                    </TableCell>
                    <TableCell className="fw-bold" style={{ backgroundColor: '#f5f5f5', color: '#333', minWidth: '300px' }}>
                      Goods Description
                    </TableCell>
                    <TableCell className="fw-bold" style={{ backgroundColor: '#f5f5f5', color: '#333' }}>
                      Condition at Origin
                    </TableCell>
                    <TableCell className="fw-bold" style={{ backgroundColor: '#f5f5f5', color: '#333' }}>
                      Condition at Destination
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {formContent?.dataRows?.length > 0 ? (
                    <>
                      {formContent?.dataRows.map((row, index) => (
                        <TableRow key={index} hover>
                          <TableCell> {index + 1}</TableCell>
                          <TableCell>
                            {isEdit ? (
                              <>
                                <Input
                                  id="condition"
                                  label="Description..."
                                  type="text"
                                  style="full-border-field"
                                  value={row?.description}
                                  onChange={(e) => {
                                    const values = { ...formContent };
                                    const valuesRows = [
                                      ...formContent?.dataRows,
                                    ];
                                    valuesRows[index].description =
                                      e.target.value;
                                    values.dataRows = valuesRows;
                                    setFormContent(values);
                                  }}
                                  inline={{ width: "-webkit-fill-available" }}
                                />
                              </>
                            ) : row?.description ? (
                              row?.description
                            ) : (
                              "-"
                            )}
                          </TableCell>
                          <TableCell>
                            {isEdit ? (
                              <Input
                                id="condition"
                                label="Condition at origin..."
                                type="text"
                                style="full-border-field"
                                value={row?.conditionAtOrigin}
                                onChange={(e) => {
                                  const values = { ...formContent };
                                  const valuesRows = [...formContent?.dataRows];
                                  valuesRows[index].conditionAtOrigin =
                                    e.target.value;
                                  values.dataRows = valuesRows;
                                  setFormContent(values);
                                }}
                                inline={{ width: "-webkit-fill-available" }}
                              />
                            ) : row?.conditionAtOrigin ? (
                              row?.conditionAtOrigin
                            ) : (
                              "-"
                            )}
                          </TableCell>
                          <TableCell>
                            {isEdit ? (
                              <Input
                                id="disclamer"
                                label="Condition at destination..."
                                type="text"
                                style="full-border-field"
                                value={row?.conditionAtDestination}
                                onChange={(e) => {
                                  const values = { ...formContent };
                                  const valuesRows = [...formContent?.dataRows];
                                  valuesRows[index].conditionAtDestination =
                                    e.target.value;
                                  values.dataRows = valuesRows;
                                  setFormContent(values);
                                }}
                                inline={{ width: "-webkit-fill-available" }}
                              />
                            ) : row?.conditionAtDestination ? (
                              row?.conditionAtDestination
                            ) : (
                              "-"
                            )}
                          </TableCell>
                        </TableRow>
                      ))}
                    </>
                  ) : (
                    <TableRow className="text-center">
                      <TableCell colSpan={5}>
                        {isLoading ? (
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "center",
                              margin: "10px 0px",
                            }}
                          >
                            <CircularProgress
                              style={{
                                color: "#00aff0",
                                height: "25px",
                                width: "25px",
                              }}
                            />
                          </Box>
                        ) : (
                          <div className="d-flex justify-content-center">
                            <p className="my-3">No Records to Show</p>
                          </div>
                        )}
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
           </PremiumCard>

            {/* Remarks */}
           <SectionHeader title="Remarks" icon={<CommentIcon />} />
           <PremiumCard sx={{ marginBottom: "32px" }}>
            <div className="pe-1">
             <Typography variant="body1" className="text-start" gutterBottom>
               <DynamicText
                 label="Remarks:"
                 textAreaLabel="Remarks..."
                 isEdit={isEdit}
                 value={formContent?.remarks}
                 onChange={(e) => {
                   let values = { ...formContent };
                   values.remarks = e.target.value;
                   setFormContent(values);
                 }}
               />
             </Typography>
            </div>
           </PremiumCard>

           {/* Authorization */}
            <PremiumCard sx={{ marginBottom: "32px" }}>
              <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', mb: 4, gap: 1 }}>
                  <Typography variant="body1">
                    WE HAVE CHECKED ALL THE ITEM LISTED AND NUMBERED
                  </Typography>
                {isEdit ? (
                  <input
                    type="text"
                    className="mx-2 input-field"
                    value={formContent?.number1}
                    onChange={(e) => {
                      let values = { ...formContent };
                      values.number1 = e.target.value;
                      setFormContent(values);
                    }}
                    style={{ width: "80px", padding: '8px', borderRadius: '6px', border: '1px solid #dee2e6' }}
                  />
                ) : (
                  <Typography variant="body1" sx={{ px: 1, textDecoration: 'underline', fontWeight: 700 }}>
                    {formContent?.number1 || "-"}
                  </Typography>
                )}
                <Typography variant="body1">to</Typography>
                {isEdit ? (
                  <input
                    type="text"
                    className="mx-2 input-field"
                    value={formContent?.number2}
                    onChange={(e) => {
                      let values = { ...formContent };
                      values.number2 = e.target.value;
                      setFormContent(values);
                    }}
                    style={{ width: "80px", padding: '8px', borderRadius: '6px', border: '1px solid #dee2e6' }}
                  />
                ) : (
                  <Typography variant="body1" sx={{ px: 1, textDecoration: 'underline', fontWeight: 700 }}>
                    {formContent?.number2 || "-"}
                  </Typography>
                )}
                <Typography variant="body1">
                    INCLUSIVE AND ACKNOWLEDGE THAT THIS IS A TRUE AND COMPLETE LIST OF THE GOODS.
                </Typography>
              </Box>

              <Grid container spacing={4}>
                 <Grid item xs={12} sm={6} className="text-center">
                   <Box sx={{ border: '1px solid #eee', borderRadius: '8px', p: 2, mb: 1 }}>
                      <div
                        style={{ height: "100px" }}
                        className="d-flex justify-content-center align-items-end"
                      >
                        {formContent?.destContractorSign?.trim()?.length == 0 ? (
                          <>
                            {formContent?.clientEmail != email && (
                              <div className="d-flex justify-content-center align-items-center h-100">
                                <label
                                  htmlFor="uploadSign2"
                                  className="premium-btn d-flex align-items-center justify-content-center cursor-pointer"
                                >
                                  {uploadText1}
                                </label>
                                <input
                                  type="file"
                                  hidden
                                  id="uploadSign2"
                                  name="uploadSign2"
                                  onChange={(e) => {
                                    if (!isLoading)
                                      uploadFileContractor(e, "destContractor");
                                  }}
                                />
                              </div>
                            )}
                          </>
                        ) : (
                          <img
                            src={`${Bucket}${formContent.destContractorSign}`}
                            height={90}
                            width={200}
                             style={{maxHeight: '90px', maxWidth: '100%', objectFit: 'contain'}}
                          />
                        )}
                      </div>
                      <div style={{ borderTop: "1px solid #000", marginTop: "10px", width: "80%", margin: "10px auto" }}></div>
                      <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
                        Contractor Carrier at DESTINATION
                      </Typography>
                   </Box>
                </Grid>
                <Grid item xs={12} sm={6} className="text-center">
                   <Box sx={{ border: '1px solid #eee', borderRadius: '8px', p: 2, mb: 1 }}>
                      <div
                        style={{ height: "100px" }}
                        className="d-flex justify-content-center align-items-end"
                      >
                        {formContent?.originContractorSign?.trim()?.length == 0 ? (
                          <>
                            {formContent?.clientEmail != email && (
                              <div className="d-flex justify-content-center align-items-center h-100">
                                <label
                                  htmlFor="uploadSign1"
                                  className="premium-btn d-flex align-items-center justify-content-center cursor-pointer"
                                >
                                  {uploadText2}
                                </label>
                                <input
                                  type="file"
                                  hidden
                                  id="uploadSign1"
                                  name="uploadSign1"
                                  onChange={(e) => {
                                    if (!isLoading)
                                      uploadFileContractor(e, "originContractor");
                                  }}
                                />
                              </div>
                            )}
                          </>
                        ) : (
                          <img
                            src={`${Bucket}${formContent.originContractorSign}`}
                            height={90}
                            width={200}
                             style={{maxHeight: '90px', maxWidth: '100%', objectFit: 'contain'}}
                          />
                        )}
                      </div>
                      <div style={{ borderTop: "1px solid #000", marginTop: "10px", width: "80%", margin: "10px auto" }}></div>
                      <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
                        Contractor Carrier at ORIGIN
                      </Typography>
                   </Box>
                </Grid>

                 <Grid item xs={12} sm={6} className="text-center">
                   <Box sx={{ border: '1px solid #eee', borderRadius: '8px', p: 2, mb: 1 }}>
                      <div
                        style={{ height: "100px" }}
                        className="d-flex justify-content-center align-items-end"
                      >
                         {formContent.clientSignDestination != "" &&
                          formContent.clientSignDestination != undefined ? (
                            <img
                              src={`${Bucket}${formContent.clientSignDestination}`}
                              height={90}
                              width={200}
                               style={{maxHeight: '90px', maxWidth: '100%', objectFit: 'contain'}}
                            />
                          ) : (
                             <>
                        {formContent?.clientEmail == email && (
                           <div className="d-flex justify-content-center align-items-center h-100">
                            <label
                                htmlFor="uploadSignClient1"
                                className="premium-btn d-flex align-items-center justify-content-center cursor-pointer"
                            >
                                {uploadTextClient1}
                            </label>
                             <input
                            type="button"
                            hidden
                            id="uploadSignClient1"
                            name="uploadSign"
                            onClick={() => {
                                setWhichSign("destClient");
                                setSignCanvas(true);
                            }}
                            />
                            </div>
                        )}
                      </>
                          )}
                      </div>
                      <div style={{ borderTop: "1px solid #000", marginTop: "10px", width: "80%", margin: "10px auto" }}></div>
                      <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
                        Client at DESTINATION
                      </Typography>
                   </Box>
                </Grid>
                <Grid item xs={12} sm={6} className="text-center">
                   <Box sx={{ border: '1px solid #eee', borderRadius: '8px', p: 2, mb: 1 }}>
                      <div
                        style={{ height: "100px" }}
                        className="d-flex justify-content-center align-items-end"
                      >
                         {formContent.clientSign != "" &&
                          formContent.clientSign != undefined ? (
                            <img
                              src={`${Bucket}${formContent.clientSign}`}
                              height={90}
                              width={200}
                               style={{maxHeight: '90px', maxWidth: '100%', objectFit: 'contain'}}
                            />
                          ) : (
                             <>
                        {formContent?.clientEmail == email && (
                           <div className="d-flex justify-content-center align-items-center h-100">
                            <label
                                htmlFor="uploadSignClient2"
                                className="premium-btn d-flex align-items-center justify-content-center cursor-pointer"
                            >
                                {uploadTextClient2}
                            </label>
                             <input
                            type="button"
                            hidden
                            id="uploadSignClient2"
                            name="uploadSign"
                            onClick={() => {
                                setWhichSign("originClient");
                                setSignCanvas(true);
                            }}
                            />
                            </div>
                        )}
                      </>
                          )}
                      </div>
                      <div style={{ borderTop: "1px solid #000", marginTop: "10px", width: "80%", margin: "10px auto" }}></div>
                      <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
                        Client at ORIGIN
                      </Typography>
                   </Box>
                </Grid>
              </Grid>
            </PremiumCard>

        </PremiumPublicLayout>
      ) : (
        <div className="no-print">
          {isLoading ? (
            <div> Loading...</div>
          ) : (
            <div> Ooops... Something went wrong...</div>
          )}
        </div>
      )}

      <PrintComponent>
        <PackingInventoryDownload
          id="content-id"
          surveyData={surveyData}
          formContent={formContent}
        />
      </PrintComponent>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000} // Adjust the duration as needed
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          severity={
            snackbarMessage?.includes("successful") ? "success" : "error"
          }
          onClose={handleCloseSnackbar}
        >
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
       {/* Add signature Modal */}
       {isSignCanvas && (
          <MySignatureCanvas
            open={isSignCanvas}
            onClose={() => {
              setSignCanvas(false);
            }}
            onSuccess={(file) => {
              if (!isLoading) uploadFile(file);
            }}
          />
        )}
    </>
  );
};
export default PackingInventoryClientSide;
